import { createTRPCReact } from '@trpc/react-query';
import { httpBatchLink } from '@trpc/client';
import type { AppRouter } from './api-types.js';

export const trpc = createTRPCReact<AppRouter>();

/** Origem das rotas HTTP puras (upload e exportação). Vazio = mesma origem. */
export const baseHttp = import.meta.env.VITE_API_URL_BASE ?? '';

export function criarClienteTrpc() {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: import.meta.env.VITE_API_URL ?? '/trpc',
        // O cookie de sessão é httpOnly: sem credentials nenhuma query autentica.
        fetch: (input, init) => fetch(input, { ...init, credentials: 'include' }),
      }),
    ],
  });
}
